import secondaryButton from '../../secondary-button/branded-solid/background/default';

const light = (params) => secondaryButton.light(params);

export default light;
